import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, Paper } from '@mui/material';
import FinancialProductResidualGridsTableHead from './FinancialProductResidualGridsTableHead';
import FinancialProductResidualGridsTableBody from './FinancialProductResidualGridsTableBody';
import { get } from '@totalsoft/change-tracking-react';

const FinancialProductResidualGridsTable = ({ 
  canWrite, 
  isNewFinancialProduct,
  onAdd,
  onCancelEdit,
  onDelete,
  onSave,
  residualGrids,  
  residualValueGridList,
  validation,
  isDirty
}) => {
  const [t] = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <FinancialProductResidualGridsTableHead canWrite={canWrite} isNewFinancialProduct={isNewFinancialProduct} onAdd={onAdd} />
          {isNewFinancialProduct && (
            <FinancialProductResidualGridsTableBody
              canWrite={canWrite}
              residualGrids={residualGrids}
              onCancelEdit={onCancelEdit}
              onDelete={onDelete}
              onSave={onSave}
              residualValueGridList={residualValueGridList}
              validation={validation}
              isDirty={isDirty}
            />
          )}
        </Table>
      </TableContainer>
      {!isNewFinancialProduct && <Placeholder message={t('FinancialProduct.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isNewFinancialProduct && (residualGrids?.length |> get) === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductResidualGridsTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  isNewFinancialProduct: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancelEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  residualGrids: PropTypes.array.isRequired,
  residualValueGridList: PropTypes.array.isRequired,
  validation: PropTypes.object.isRequired,
  isDirty: PropTypes.bool.isRequired
};

export default FinancialProductResidualGridsTable;
